module.exports = __webpack_public_path__ + "img/opp-xml-view.450205e0.png";